export var dataHooks = {
    accountSelector: {
        container: 'account-selector-container',
        title: 'account-selector-title',
        loggedInBadge: 'account-selector-logged-in-badge',
        subTitle: 'account-selector-subtitle',
        actionBtn: 'account-selector-action-btn',
        accountItemPrefix: 'account-item',
    },
};
export var LOGIN_WEBAPP_PREFIX = '/_api/wix-html-login-webapp';
export var ACCOUNT_SERVER_PREFIX = '/_api/account-server';
export var USER_ACCOUNTS_BY_EMAIL = "".concat(LOGIN_WEBAPP_PREFIX, "/getUserAccountsByEmail");
export var isBlankGavatar = function (key) {
    if (key === void 0) { key = ''; }
    return new RegExp(/(https?:\/\/(.+?\.)?gravatar\.com(\/[A-Za-z0-9\-\._~:\/\?#\[\]@!$&'\(\)\*\+,;\=]*)?)(\?|&)((d=blank)(&?))+/g).test(key);
};
//# sourceMappingURL=constants.js.map